import controller from './oo-admin-attribute-editor.controller';
import template from './oo-admin-attribute-editor.html';

export default {
	bindings:     {
		attribut: '=ngModel',
		node:     '<?',
		form:     '<',
		disabled: '<?ngDisabled',
	},
	controller,
	template,
	controllerAs: '$ctrl',
	require:      {
		ngModelCtrl: '?ngModel',
	},
};
